var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'clsx';
import { Inline } from '../inline/Inline';
import { wrapperStyles, linkStyles } from './SkipToContent.css';
export const SkipToContent = ({ links }) => {
    return (_jsx(Inline, { align: "center", className: wrapperStyles, children: links.map((_a, index) => {
            var { className, label } = _a, rest = __rest(_a, ["className", "label"]);
            return (_jsx("a", Object.assign({ className: cx(linkStyles, className) }, rest, { children: label }), `skipLink-${index}`));
        }) }));
};
